import React from 'react'
import { InputMask } from 'primereact/inputmask'

/**
 * CPF, data de nascimento, sexo de nascimento e gênero — compartilhado entre
 * Meus dados (editUser) e edição de colaborador (formEmployeePersonalData).
 * Recebe o mesmo `formik` do formulário pai.
 */
export function userBirthdayForInput(user) {
    if (!user || !user.birthday) return ''
    const s = String(user.birthday)
    return s.length >= 10 ? s.slice(0, 10) : s
}

export default function UserPersonalDataFields({ formik }) {
    return (
        <>
            <div className="row g-2 px-0">
                <div className="col-sm-6 col-md-4">
                    <label className="form-label">
                        CPF <span className="text-danger">*</span>
                    </label>
                    <InputMask
                        className="form-control"
                        style={{ padding: '0.37rem 0.75rem' }}
                        value={formik.values.legalId}
                        onChange={e => formik.setFieldValue('legalId', e.target.value)}
                        mask="999.999.999-99"
                        placeholder="999.999.999-99"
                    />
                    {formik.errors.legalId ? (
                        <span className="text-vermelho small d-block">{formik.errors.legalId}</span>
                    ) : null}
                </div>
                <div className="col-sm-6 col-md-4">
                    <label className="form-label">
                        Data de nascimento <span className="text-danger">*</span>
                    </label>
                    <input
                        className="form-control"
                        name="birthday"
                        type="date"
                        autoComplete="off"
                        {...formik.getFieldProps('birthday')}
                    />
                    {formik.errors.birthday ? (
                        <span className="text-vermelho small d-block">{formik.errors.birthday}</span>
                    ) : null}
                </div>
            </div>

            <div className="row g-2 px-0 mt-3">
                <div className="col-sm-6 col-md-4">
                    <label className="form-label">
                        Sexo de nascimento <span className="text-danger">*</span>
                    </label>
                    <select className="form-select" name="born_sex" required {...formik.getFieldProps('born_sex')}>
                        <option disabled value="">
                            Selecione
                        </option>
                        <option value="MA">Masculino</option>
                        <option value="FE">Feminino</option>
                        <option value="OR">Outro</option>
                        <option value="NO">Não informado</option>
                    </select>
                    {formik.errors.born_sex ? (
                        <span className="text-vermelho small d-block">{formik.errors.born_sex}</span>
                    ) : null}
                </div>
            </div>

            <div className="row g-2 px-0 mt-3">
                <div className="col-12 col-lg-8">
                    <label className="form-label">
                        Gênero com o qual se identifica <span className="text-danger">*</span>
                    </label>
                    <select className="form-select" name="gender" required {...formik.getFieldProps('gender')}>
                        <option disabled value="">
                            Selecione
                        </option>
                        <option value="0">Prefiro não responder</option>
                        <option value="1">
                            Mulher cisgênero: pessoa que se reconhece pelo gênero que lhe foi atribuído ao nascer
                        </option>
                        <option value="2">
                            Mulher transgênero: pessoa que se reconhece por outro gênero, diferente do atribuído ao nascer
                        </option>
                        <option value="3">
                            Homem cisgênero: pessoa que se reconhece pelo gênero que lhe foi atribuído ao nascer
                        </option>
                        <option value="4">
                            Homem transgênero: pessoa que se reconhece por outro gênero, diferente do atribuído ao nascer
                        </option>
                        <option value="5">
                            Não binário: pessoa que se reconhece fora do sistema binário de gênero
                        </option>
                        <option value="6">Sem gênero: ausência de gênero</option>
                        <option value="7">Gênero fluído</option>
                        <option value="8">Outro</option>
                    </select>
                    {formik.errors.gender ? (
                        <span className="text-vermelho small d-block">{formik.errors.gender}</span>
                    ) : null}
                </div>
            </div>
        </>
    )
}
